import { Component} from '@angular/core';
import { MdDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-app-loader',
  template: require('./app-loader.component.html')
  
})
export class AppLoaderComponent {
  title;
  percentage;
  message;
  constructor(public dialogRef: MdDialogRef<AppLoaderComponent>) {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/services/app-loader/app-loader.component.ts